module.exports = __webpack_public_path__ + "market/static/img/hammer.91f3a7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/hammer.png
// module id = N/Hr
// module chunks = 1